export enum I18NSera {
    startsWith = 'PRIMENG.STARTS_WITH.LBL',
    contains = 'PRIMENG.CONTAINS.LBL',
    notContains = 'PRIMENG.NOT_CONTAINS.LBL',
    endsWith = 'PRIMENG.ENDS_WITH.LBL',
    equals = 'PRIMENG.EQUALS.LBL',
    notEquals = 'PRIMENG.NOT_EQUALS.LBL',
    noFilter = 'PRIMENG.NO_FILTER.LBL',
    lt = 'PRIMENG.LT.LBL',
    lte = 'PRIMENG.LTE.LBL',
    gt = 'PRIMENG.GT.LBL',
    gte = 'PRIMENG.GTE.LBL',
    is = 'PRIMENG.IS.LBL',
    isNot = 'PRIMENG.IS_NOT.LBL',
    before = 'PRIMENG.BEFORE.LBL',
    after = 'PRIMENG.AFTER.LBL',
    dateIs = 'PRIMENG.DATEIS.LBL',
    dateIsNot = 'PRIMENG.DATE_IS_NOT.LBL',
    dateBefore = 'PRIMENG.DATE_BEFORE.LBL',
    dateAfter = 'PRIMENG.DATE_AFTER.LBL',
    clear = 'PRIMENG.CLEAR.LBL',
    apply = 'PRIMENG.APPLY.LBL',
    matchAll = 'PRIMENG.MATCH_ALL.LBL',
    matchAny = 'PRIMENG.MATCH_ANY.LBL',
    addRule = 'PRIMENG.ADD_RULE.LBL',
    removeRule = 'PRIMENG.REMOVE_RULE.LBL',
    accept = 'PRIMENG.ACCEPT.LBL',
    reject = 'PRIMENG.REJECT.LBL',
    choose = 'PRIMENG.CHOOSE.LBL',
    upload = 'PRIMENG.UPLOAD.LBL',
    cancel = 'PRIMENG.CANCEL.LBL',
    today = 'PRIMENG.TODAY.LBL',
    weak = 'PRIMENG.WEAK.LBL',
    medium = 'PRIMENG.MEDIUM.LBL',
    strong = 'PRIMENG.STRONG.LBL',
    passwordPrompt = 'PRIMENG.PASSWORD_PROMPT.LBL',
    emptyMessage = 'PRIMENG.EMPTYMESSAGE.LBL',
    emptyFilterMessage = 'PRIMENG.EMPTY_FILTER_MESSAGE.LBL',
    dayNames = 'PRIMENG.DAY_NAMES.LBL',
    dayNamesShort = 'PRIMENG.DAY_NAMES_SHORT.LBL',
    dayNamesMin = 'PRIMENG.DAY_NAMES_MIN.LBL',
    monthNames = 'PRIMENG.MONTH_NAMES.LBL',
    monthNamesShort = 'PRIMENG.MONTH_NAMES_SHORT.LBL',
    dateFormat = 'PRIMENG.DATE_FORMAT.LBL'
}
